var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Shortage Area Category")]),_c('teacher-bonus-table',{attrs:{"fiscal-year":_vm.fiscalYear,"lea":_vm.selectedLea.number,"category":"ShortageArea"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }